<template>
    <div class="main_holder login">
        <div class="content_holder">
            <div class="login_box">

                <div class="password_login_box" v-if="!production">
                    <div class="input_holder">
                        Elektronska pošta: <input type="email" maxlength="50" v-model="email" ref="email">
                        Geslo: <input type="password" maxlength="50" v-model="password" @keyup.enter="loginUser()" ref="password">
                    </div>

                    <div class="input_holder button_holder">
                        <button class="button" @click="loginUser({email: email, password: password})">Vpis</button>
                    </div>

                    <div class="as_link pass_recovery_link" @click="passRecoveryClick()">
                        <span>Ste pozabili geslo?</span>
                    </div>
                </div>

                <button class="button sso_login_button" @click="loginWithAzureSSO()" :class="{disabled:loading}" :disabled="loading">
                    <font-awesome-icon :icon="['fas', 'right-to-bracket']" />
                    {{ loading ? 'Preusmerjanje na prijavo ...' : 'Vpis z digitalno identiteto UL' }}
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions } from 'vuex';
import {
    clearStaleMsalRedirectState,
    getLoginRequest,
    getMsalInstance,
    isInteractionInProgressError,
    isUserCancelledError,
} from '@/auth/msal';

export default {
    name: 'Login',
    data() {
        return {
            msalInstance: null,
            loading: false,
            error: null,
            production: window.location.hostname === 'porocanje.uni-lj.si',
            email: '',
            password: '',
        };
    },
    methods: {
        ...mapActions([
            'showModal',
            'loginUserSaml',
            'loginUser',
            'passRecovery'
        ]),
        async loginWithAzureSSO() {
            if (this.loading) {
                return;
            }

            this.loading = true;

            try {
                clearStaleMsalRedirectState();
                this.msalInstance = await getMsalInstance(this.msalInstance);
                await this.msalInstance.loginRedirect(getLoginRequest());
            } catch (error) {
                console.error('Azure SSO login failed:', error);

                if (isInteractionInProgressError(error)) {
                    clearStaleMsalRedirectState();
                }

                let error_string = 'Napaka pri prijavi z Microsoft Azure. Prosimo, poskusite ponovno. \n\n Podrobnosti napake: ' + error.message;

                if (isInteractionInProgressError(error)) {
                    error_string = 'Prijava je že v teku. Prosimo, osvežite stran in poskusite znova.';
                }

                if (!isUserCancelledError(error)) {
                    this.showModal({ component: 'ModalError', data: error_string });
                }

                this.loading = false;
            }
        },

        passRecoveryClick(){
            if(!this.email){
                this.showModal({component: 'ModalWarning', data:{title:"Vnestie elektronsko pošto", description:"Za nadaljevanje, prosimo vpišite vašo elektronsko pošto"}});
            }
            else
                this.passRecovery({email: this.email});
        },
    },
};
</script>

<style lang="scss" scoped>
</style>
